/* eslint-disable react/no-multi-comp */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  Typography,
  Button,
  Grid2,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
} from '@mui/material';

import { Paper } from 'components';
import Swal from 'sweetalert2';

// Component styles
import { makeStyles } from '@mui/styles';
import styles from './styles';
import { useIntl } from 'react-intl';
import {
  changeChargeStatus,
  deleteCharge,
  getChargeOwnerData,
} from 'js/actions/chargeActions';

import VoltageIndicator from './VoltageIndicator';
import { Settings } from '@mui/icons-material';
import { isAllowed } from 'helpers';
import { DataGrid } from '@mui/x-data-grid';
const useStyles = makeStyles(styles);

export default function ChargeCard(props) {
  const intl = useIntl();
  const { groupId } = props;
  const { state } = useLocation();
  const meter = state?.meter;
  const group = state?.group;
  const user = useSelector((state) => state.user.user);
  const classes = useStyles();
  const {
    className,
    charge,
    setShowDetails,
    setSelectedCharge,
    setOwnerName,
    setSnapShopView,
    setSolarCapacity,
    snapShopView,
    typeEnergy,
    setOpenReceiptDialog,
    setOpenApportiments,
  } = props;
  const rootClassName = classNames(classes.root, className);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { consumes } = charge;
  const consumesTable = [consumes[0], consumes[1]];

  const data = [];
  let obj;

  const dataSolar = [];
  let objSolar;

  const columns = [
    {
      headerName: '',
      field: 'med',
      align: 'center',
      headerAlign: 'center',
      fontSize: '1rem',
      width: 100,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            fontWeight: '900',
            fontSize: '1em',
            textAlign: 'center',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({
        id: 'app.metersCards.card.gridCard.baseCol',
      }),
      field: 'bas',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#8CBA42',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({
        id: 'app.metersCards.card.gridCard.intermidateCol',
      }),
      field: 'int',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#EAAB36',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({
        id: 'app.metersCards.card.gridCard.tipCol',
      }),
      field: 'punt',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#D64539',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
  ];

  const columnsSolar = [
    {
      headerName: '',
      field: 'med',
      align: 'center',
      headerAlign: 'center',
      width: 100,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            fontWeight: '900',
            fontSize: '1em',
            textAlign: 'center',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({
        id: 'app.metersCards.card.gridCard.baseCol',
      }),
      field: 'bas',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#8CBA42',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value || '-'}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({
        id: 'app.metersCards.card.gridCard.intermidateCol',
      }),
      field: 'int',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#EAAB36',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value || '-'}
        </div>
      ),
    },
    {
      headerName: intl.formatMessage({
        id: 'app.metersCards.card.gridCard.tipCol',
      }),
      field: 'punt',
      align: 'center',
      headerAlign: 'center',
      flex: 1,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor: '#D64539',
            color: '#FFF',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '.95em',
            width: '100%',
          }}
        >
          {params.value || '-'}
        </div>
      ),
    },
  ];

  consumesTable.forEach((element) => {
    obj = {
      med: element[0],
      bas: element[1] ? element[1].replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
      int: element[2] ? element[2].replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
      punt: element[3] ? element[3].replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
    };

    if (charge.charge_status == 0 || charge.type_unit == 'VOLTAJE') {
      obj = {
        med: element[0],
        bas: '-',
        int: '-',
        punt: '-',
      };
    }

    data.push(obj);
  });

  consumesTable.forEach((element) => {
    objSolar = {
      med: element[0],
      bas: element[1] ? element[1].replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
      int: element[1] ? element[2].replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
      punt: element[1] ? element[3].replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
    };

    if (charge.charge_status == 0 || charge.type_unit == 'VOLTAJE') {
      objSolar = {
        med: element[0],
        bas: '-',
        int: '-',
        punt: '-',
      };
    }

    dataSolar.push(objSolar);
  });

  const handleChangeChargeStatus = () => {
    let txtTextKey = '';
    let newStatus = 0;

    if (charge.charge_status == 1) {
      txtTextKey =
        'app.chargesCards.card.gridCard.msgChangeChStat.text.turnOff';
      newStatus = 0;
    } else {
      txtTextKey = 'app.chargesCards.card.gridCard.msgChangeChStat.text.turnOn';
      newStatus = 1;
    }

    Swal.fire({
      title: intl.formatMessage({
        id: 'app.chargesCards.card.gridCard.msgChangeChStat.title',
      }),
      text: intl.formatMessage({ id: txtTextKey }),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({
        id: 'app.chargesCards.card.gridCard.msgChangeChStat.btnConfirm',
      }),
      cancelButtonText: intl.formatMessage({
        id: 'app.chargesCards.card.gridCard.msgChangeChStat.btnCancel',
      }),
    }).then((result) => {
      if (result.value == true) {
        dispatch(changeChargeStatus(charge, newStatus, groupId));
      }
    });
  };

  const displayChargeStatusIcon = () => {
    if (charge.charge_status == 1) {
      return (
        <div
          style={{ textAlign: 'left', verticalAlign: 'top' }}
          role="button"
          onClick={handleChangeChargeStatus}
          onKeyDown={handleChangeChargeStatus}
          tabIndex={0}
        >
          <img
            alt="turn on"
            src="/images/charge_turn_on_count.png"
            style={{ width: '22px', height: '22px', marginBottom: '15px' }}
          />
        </div>
      );
    } else {
      return (
        <div
          style={{ textAlign: 'left', verticalAlign: 'top' }}
          role="button"
          tabIndex={0}
          onKeyDown={handleChangeChargeStatus}
          onClick={handleChangeChargeStatus}
        >
          <img
            alt="turn off"
            src="/images/charge_turn_off_count.png"
            style={{ width: '22px', height: '22px', marginBottom: '15px' }}
          />
        </div>
      );
    }
  };

  const displayButton = () => {
    if (charge.type_unit == 'VOLTAJE') {
      return (
        <Link
          to={{
            pathname: `/group/${groupId}/charge/${charge.id}/alert`,
            state: {
              charge: charge,
            },
          }}
        >
          <Button
            style={{
              width: '100%',
              backgroundColor: '#D64539',
              color: 'white',
            }}
            variant="contained"
          >
            {intl.formatMessage({ id: 'app.metersCards.card.voltageAlert' })}
          </Button>
        </Link>
      );
    } else {
      return (
        <Link
          state={{
            charge: charge,
            meter: meter,
            group: group,
          }}
          to={
            typeEnergy === 2
              ? `/dashboardSolarCharge/group/${groupId}/charge/${charge.id}`
              : `/chargeDashboard/group/${groupId}/charge/${charge.id}`
          }
        >
          <Button
            color="secondary"
            style={{
              width: '100%',
              backgroundColor: typeEnergy === 2 ? '#45B880' : '',
            }}
            variant="contained"
          >
            {intl.formatMessage({ id: 'app.chargesCards.card.boardBtn' })}{' '}
            {typeEnergy === 2 ? 'Solar' : ''}
          </Button>
        </Link>
      );
    }
  };

  const displayCo2Info = () => {
    if (charge.type_unit == 'VOLTAJE') {
      return (
        <div>
          <img
            alt="co2"
            src="/images/icono3_co2.png"
            style={{ width: '50px', height: '50px' }}
          />
          <Typography style={{ color: '#FF8024', fontWeight: 'bold' }}>
            {charge.charge_status === 0 ? '' : charge.co2 + ' kg *'}
          </Typography>
        </div>
      );
    } else {
      return (
        <div>
          <img
            alt="co2"
            src={
              typeEnergy === 2
                ? '/images/co2-icon.png'
                : '/images/icono3_co2.png'
            }
            style={{ width: '50px' }}
          />
          <Typography
            style={{
              color: typeEnergy === 2 ? '#45B880' : '#FF8024',
              fontWeight: 'bold',
            }}
          >
            {charge.charge_status == 0 ? '' : charge.co2 + ' kg *'}
          </Typography>
        </div>
      );
    }
  };

  const displayChargeName = () => {
    if (charge.is_father == 1) {
      return (
        <Typography variant="h5">
          {charge.name}
          <br />
        </Typography>
      );
    } else {
      return (
        <Typography variant="h5">
          {charge.name}
          <br />
        </Typography>
      );
    }
  };

  const displayVoltage = () => {
    return (
      <div
        style={{
          fontFamily: 'Lato, Helvetica Neue,Arial',
          textAlign: 'center',
        }}
      >
        <VoltageIndicator charge={charge} />
      </div>
    );
  };

  // ;

  const handleShowMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const rateHorary = (rate) => {
    const consumeSum = () => {
      return charge.consumes[1]
        .slice(1)
        .reduce((sum, value) => sum + parseFloat(value), 0)
        .toFixed(2);
    };

    const demandMax = () => {
      return Math.max(
        ...charge.consumes[0].slice(1).map((item) => parseFloat(item))
      );
    };

    const rowsWithId = data.map((row, index) => ({ ...row, id: index }));

    return rate !== 1 ? (
      <Grid2 container={true}>
        <Grid2 size={6}>
          <Typography
            className={classes.description}
            sx={{ marginTop: '10px', color: 'carbon' }}
            variant="h5"
          >
            {intl.formatMessage({
              id: 'app.groupsCards.card.maxDemPerDay',
            })}
          </Typography>
        </Grid2>
        <Grid2 size={6}>
          <Typography
            className={classes.description}
            sx={{
              color: '#A53693',
              fontWeight: '600',
              marginTop: '10px',
            }}
            variant="h4"
          >
            {demandMax()} kW
          </Typography>
        </Grid2>
        <Grid2 size={6}>
          <Typography
            className={classes.description}
            sx={{ marginTop: '10px', color: 'carbon' }}
            variant="h5"
          >
            {intl.formatMessage({
              id: 'app.groupsCards.card.totalKwPerDay',
            })}
          </Typography>
        </Grid2>
        <Grid2 size={6}>
          <Typography
            className={classes.description}
            sx={{
              color: '#A53693',
              fontWeight: '600',
              marginTop: '10px',
            }}
            variant="h4"
          >
            {consumeSum()} kWh
          </Typography>
        </Grid2>
      </Grid2>
    ) : (
      charge.type_unit !== 'VOLTAJE' && (
        <DataGrid
          className={classes.table}
          columns={columns}
          rows={rowsWithId}
          disableSelectionOnClick={true}
          disableColumnFilter={true}
          disableColumnMenu={true}
          disableColumnSelector={true}
          disableSorting={true}
          hideFooter={true}
          sx={{
            boxShadow: 3,
            borderRadius: 1,
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: '.9rem',
            },
            '& .MuiDataGrid-row': {
              fontSize: 15,
              padding: 0,
            },
            '& .MuiDataGrid-cell': {
              padding: '1px 0.5px',
            },
            '& .MuiDataGrid-columnHeaders': {
              textAlign: 'center',
              padding: '0',
              fontSize: '0.9em',
              fontWeight: '900',
              minWidth: '25%',
            },
          }}
        />
      )
    );
  };

  const rowsWithIdSolar = dataSolar.map((row, index) => ({
    ...row,
    id: index,
  }));

  const sunFill = () => {
    if (charge.solar_percentage >= 100) {
      return (
        <Grid2
          size={6}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <img
            alt="sun"
            src="/images/sol-05.png"
            style={{ width: '20%', height: '100%' }}
          />
          <Typography sx={{ color: '#fcc02d', fontWeight: 'bold' }}>
            {charge.solar_percentage.toFixed(2)} %
          </Typography>
        </Grid2>
      );
    } else if (charge.solar_percentage >= 75) {
      return (
        <Grid2
          size={6}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <img
            alt="sun"
            src="/images/sol-04.png"
            style={{ width: '20%', height: '100%' }}
          />
          <Typography sx={{ color: '#fcc02d', fontWeight: 'bold' }}>
            {charge.solar_percentage.toFixed(2)} %
          </Typography>
        </Grid2>
      );
    } else if (charge.solar_percentage >= 45) {
      return (
        <Grid2
          size={6}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <img
            alt="sun"
            src="/images/sol-03.png"
            style={{ width: '20%', height: '100%' }}
          />
          <Typography sx={{ color: '#fcc02d', fontWeight: 'bold' }}>
            {charge.solar_percentage.toFixed(2)} %
          </Typography>
        </Grid2>
      );
    } else if (charge.solar_percentage >= 25) {
      return (
        <Grid2
          size={6}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <img
            alt="sun"
            src="/images/sol-02.png"
            style={{ width: '20%', height: '100%' }}
          />
          <Typography sx={{ color: '#fcc02d', fontWeight: 'bold' }}>
            {charge.solar_percentage.toFixed(2)} %
          </Typography>
        </Grid2>
      );
    } else {
      return (
        <Grid2
          size={6}
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <img
            alt="sun"
            src="/images/sol-01.png"
            style={{ width: '20%', height: '100%' }}
          />
          <Typography sx={{ color: '#fcc02d', fontWeight: 'bold' }}>
            {charge.solar_percentage.toFixed(2)} %
          </Typography>
        </Grid2>
      );
    }
  };

  const handleShowDetails = () => {
    setSelectedCharge(charge);
    setShowDetails(true);
    setAnchorEl(null);
  };

  const handleOpenReceiptDialog = (charge) => {
    dispatch(getChargeOwnerData(charge ? charge.id : null));
    setSelectedCharge(charge);
    setOpenReceiptDialog(true);
    setAnchorEl(null);
  };

  const handleSnapShot = () => {
    setSnapShopView(true);
    setSelectedCharge(charge);
    setAnchorEl(null);
  };

  const handleApportiments = () => {
    setOpenApportiments(true);
    setAnchorEl(null);
    setSelectedCharge(charge);
  };

  const deleteChargeData = (charge) => {
    Swal.fire({
      title: `${intl.formatMessage({ id: 'app.chargesCards.deleteChargeBtn.title' })} `,
      text: `${intl.formatMessage({ id: 'app.chargesCards.deleteChargeBtn.text' })} ${charge.name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({
        id: 'app.chargesCards.deleteChargeBtn.confirmation',
      }),
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: intl.formatMessage({
            id: 'app.chargesCards.deleteChargeBtn.titleConfirmation',
          }),
          text: intl.formatMessage({
            id: 'app.chargesCards.deleteChargeBtn.textConfirmation',
          }),
          icon: 'success',
        });
        dispatch(deleteCharge(charge.id));
      }
    });
  };

  const handleCapacity = (charge) => {
    setSolarCapacity(true);
    setSelectedCharge(charge);
    setAnchorEl(null);
  };

  return (
    <Paper className={rootClassName}>
      <div className={classes.details}>
        {typeEnergy === 2 ? (
          <Grid2 container spacing={1}>
            <Grid2
              alignItems="flex-start"
              container={true}
              justifyContent="space-between"
              spacing={1}
              sx={{
                margin: '2px 2px .5rem',
                justifyContent: 'space-between',
              }}
              size={12}
            >
              {sunFill()}
              <Grid2 className={classes.buttonMore} size={6}>
                <IconButton
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  aria-label="settings"
                  className={classes.settings}
                  onClick={handleShowMenu}
                >
                  <Tooltip
                    title={intl.formatMessage({ id: 'app.details.btn' })}
                  >
                    <Settings />
                  </Tooltip>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  id="simple-menu"
                  onClose={handleClose}
                  open={Boolean(anchorEl)}
                >
                  <MenuItem onClick={handleShowDetails}>
                    {intl.formatMessage({ id: 'app.details.btn' })}
                  </MenuItem>
                  <MenuItem>
                    <Link
                      style={{ color: '#000', textDecoration: 'none' }}
                      to={`/invoiceDataCharge/${charge.id}`}
                      state={{ charge: charge, groupId: groupId }}
                    >
                      {intl.formatMessage({
                        id: 'app.chargesCards.invDataBtn',
                      })}
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={() => handleOpenReceiptDialog(charge)}>
                    {intl.formatMessage({
                      id: 'app.chargesCards.receiptData.title',
                    })}
                  </MenuItem>
                  {isAllowed(user.permissions, ['charge_delete']) && (
                    <MenuItem onClick={() => deleteChargeData(charge)}>
                      {intl.formatMessage({
                        id: 'app.chargesCards.deleteChargeBtn',
                      })}
                    </MenuItem>
                  )}
                  {isAllowed(user.permissions, ['charge_update']) && (
                    <MenuItem>
                      <Link
                        style={{ color: '#000', textDecoration: 'none' }}
                        to={`/updateCharge/${charge.id}`}
                        state={{ charge: charge }}
                      >
                        {intl.formatMessage({
                          id: 'app.chargesCards.editChargeBtn',
                        })}
                      </Link>
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => handleSnapShot()}>SnapShot</MenuItem>
                  <MenuItem onClick={() => handleCapacity(charge)}>
                    Capacidad Mensual Instalada
                  </MenuItem>
                </Menu>
              </Grid2>
              <Grid2
                container={true}
                direction="column"
                justify="top"
                justifyContent="top"
                size={6}
                sx={{ padding: '2px' }}
              >
                {displayChargeStatusIcon()}

                {displayChargeName()}

                <div style={{ height: '15px' }} />
              </Grid2>
              <Grid2
                alignItems="right"
                direction="column"
                container={true}
                size={4}
                justifyContent="center"
                sx={{ textAlign: 'right' }}
              >
                <div>{displayCo2Info()}</div>
              </Grid2>
            </Grid2>
            {charge.type_unit !== 'VOLTAJE' && (
              <Grid2 size={12}>
                <DataGrid
                  className={classes.table}
                  columns={columnsSolar}
                  rows={rowsWithIdSolar}
                  disableSelectionOnClick={true}
                  disableColumnFilter={true}
                  disableColumnMenu={true}
                  disableColumnSelector={true}
                  disableSorting={true}
                  hideFooter={true}
                  sx={{
                    boxShadow:
                      '0px 1px 5px 5px rgba(69, 184, 128, 0.5), 0px 2px 2px 0px rgba(69, 184, 128, 0.5), 0px 3px 1px -2px rgba(69, 184, 128, 0.5)',
                    height: 'auto',
                    borderRadius: 1,
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontSize: '.9rem',
                    },
                    '& .MuiDataGrid-row': {
                      fontSize: 15,
                      padding: 0,
                    },
                    '& .MuiDataGrid-cell': {
                      padding: '1px 0.5px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      textAlign: 'center',
                      padding: '0',
                      fontSize: '0.9em',
                      fontWeight: '900',
                      minWidth: '25%',
                    },
                  }}
                />
              </Grid2>
            )}
            <Grid2
              size={12}
              sx={{
                display: 'flex',
                gap: '2rem',
                justifyContent: 'flex-end',
                marginRight: '1rem',
              }}
            >
              <Typography
                className={classes.description}
                sx={{ marginTop: '10px', color: '#000', fontWeight: '600' }}
                variant="h5"
              >
                {intl.formatMessage({
                  id: 'app.chargesSolarCards.card.estAmtPerDay',
                })}
              </Typography>
              <Typography
                className={classes.description}
                sx={{
                  color: '#218A1D',
                  fontWeight: '600',
                  marginTop: '10px',
                }}
                variant="h5"
              >
                {charge.charge_status == 0 ? '' : '$ ' + charge.total}
              </Typography>
            </Grid2>
            {/* <Grid
              item
              style={{ textAlign: 'center' }}
              xs={12}
            >
              {displayVoltage()}
            </Grid> */}
            <Grid2 size={12}>{displayButton()}</Grid2>
            <Grid2 size={12}>
              <Typography
                sx={{
                  fontSize: '.9em',
                  textAlign: 'center',
                  visibility: 'visible',
                }}
                variant="body1"
              >
                {intl.formatMessage({
                  id: 'app.chargesCards.card.meassCurrMonth',
                })}
              </Typography>
              <Typography
                sx={{
                  fontSize: '.9em',
                  textAlign: 'center',
                  visibility: 'visible',
                }}
                variant="body1"
              >
                {intl.formatMessage({ id: 'app.chargesCards.card.co2Msg' })}
              </Typography>
            </Grid2>
          </Grid2>
        ) : (
          <Grid2 container={true} spacing={1}>
            <Grid2
              alignItems="flex-start"
              container={true}
              justifyContent="space-between"
              spacing={1}
              sx={{
                margin: '2px 2px 1rem',
                justifyContent: 'space-between',
              }}
              size={12}
            >
              <Grid2 className={classes.buttonMore} size={12}>
                <IconButton
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  aria-label="settings"
                  className={classes.settings}
                  onClick={handleShowMenu}
                >
                  <Tooltip
                    title={intl.formatMessage({ id: 'app.details.btn' })}
                  >
                    <Settings />
                  </Tooltip>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  id="simple-menu"
                  onClose={handleClose}
                  open={Boolean(anchorEl)}
                >
                  <MenuItem onClick={handleShowDetails}>
                    {intl.formatMessage({ id: 'app.details.btn' })}
                  </MenuItem>
                  <MenuItem>
                    <Link
                      style={{ color: '#000', textDecoration: 'none' }}
                      to={`/invoiceDataCharge/${charge.id}`}
                      state={{ charge: charge, groupId: groupId }}
                    >
                      {intl.formatMessage({
                        id: 'app.chargesCards.invDataBtn',
                      })}
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={() => handleOpenReceiptDialog(charge)}>
                    {intl.formatMessage({
                      id: 'app.chargesCards.receiptData.title',
                    })}
                  </MenuItem>
                  {isAllowed(user.permissions, ['charge_delete']) && (
                    <MenuItem onClick={() => deleteChargeData(charge)}>
                      {intl.formatMessage({
                        id: 'app.chargesCards.deleteChargeBtn',
                      })}
                    </MenuItem>
                  )}

                  {isAllowed(user.permissions, ['charge_update']) && (
                    <MenuItem>
                      <Link
                        style={{ color: '#000', textDecoration: 'none' }}
                        to={`/updateCharge/${charge.id}`}
                        state={{ charge: charge }}
                      >
                        {intl.formatMessage({
                          id: 'app.chargesCards.editChargeBtn',
                        })}
                      </Link>
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => handleSnapShot()}>SnapShot</MenuItem>
                  <MenuItem onClick={() => handleApportiments()}>
                    Prorrateo de Cargas
                  </MenuItem>
                </Menu>
              </Grid2>
              <Grid2
                container={true}
                direction="column"
                justify="top"
                justifyContent="top"
                size={6}
                sx={{ padding: '2px' }}
              >
                {displayChargeStatusIcon()}

                {displayChargeName()}

                <div style={{ height: '15px' }} />
              </Grid2>
              <Grid2
                alignItems="center"
                direction="column"
                container={true}
                justifyContent="center"
                size={4}
                sx={{ textAlign: 'right' }}
              >
                <div>{displayCo2Info()}</div>
              </Grid2>
            </Grid2>
            <Grid2 size={12}>{rateHorary(charge.rate_horary)}</Grid2>
            {charge.type_unit !== 'VOLTAJE' && (
              <Grid2
                size={12}
                sx={{
                  display: 'flex',
                  gap: '2rem',
                  justifyContent: 'flex-end',
                  marginRight: '1rem',
                }}
              >
                <Typography
                  className={classes.description}
                  sx={{ marginTop: '10px', color: '#000', fontWeight: '600' }}
                  variant="h5"
                >
                  {intl.formatMessage({
                    id: 'app.chargesCards.card.estAmtPerDay',
                  })}
                </Typography>
                <Typography
                  className={classes.description}
                  sx={{
                    color: '#218A1D',
                    fontWeight: '600',
                    marginTop: '10px',
                  }}
                  variant="h5"
                >
                  {charge.charge_status == 0 ? '' : '$ ' + charge.total}
                </Typography>
              </Grid2>
            )}
            <Grid2 sx={{ textAlign: 'center' }} size={12}>
              {displayVoltage()}
            </Grid2>
            <Grid2 size={12}>{displayButton()}</Grid2>
            <Grid2 size={12}>
              <Typography
                sx={{
                  fontSize: '.9em',
                  textAlign: 'center',
                  visibility: 'visible',
                }}
                variant="body1"
              >
                {intl.formatMessage({
                  id: 'app.chargesCards.card.meassCurrMonth',
                })}
              </Typography>
              <Typography
                sx={{
                  fontSize: '.9em',
                  textAlign: 'center',
                  visibility: 'visible',
                }}
                variant="body1"
              >
                {intl.formatMessage({ id: 'app.chargesCards.card.co2Msg' })}
              </Typography>
              {charge.apportionment !== 0 && (
                <Typography
                  textAlign="center"
                  variant="body2"
                  textTransform="capitalize"
                  fontStyle="italic"
                >
                  Esta carga esta siendo prorrateada
                </Typography>
              )}
            </Grid2>
          </Grid2>
        )}
      </div>
    </Paper>
  );
}
